import React from "react";
import { Link } from "react-router-dom";
import "./Main.css";

function WebBuilderHero() {
  const heroData = {
    title: "Build Your Healthcare Website",
    subtitle: "No Coding Required",
    description:
      "Create a professional, secure, and compliant website for your healthcare practice, with integrated tools like appointment booking, EMRs, invoicing, and patient records.",
    primaryCTA: {
      text: "Request a Demo",
      link: "/request-a-demo?product=Web-Builder",
      className: "btn btn-brand-03 btn-rounded",
    },
    secondaryCTA: {
      text: "See Live Examples",
      link: "#trusted-providers",
      className: "btn btn-outline-brand-03 btn-rounded",
    },
    image: "/assets/img/homepage-wb.svg",
  };

  // Glassmorphism Layout
  const renderGlassmorphism = () => (
    <div className="container">
      <div className="row align-items-center min-vh-75">
        <div className="col-lg-9 col-md-12">
          <div className="hero-glass-card p-5 hero-glass-animated">
            {heroData.subtitle && (
              <span className="badge badge-primary mb-3 d-inline-block hero-glass-badge">
                {heroData.subtitle}
              </span>
            )}
            <h1 className="font-weight-bold mb-4 hero-glass-title">{heroData.title}</h1>
            <p className="lead mb-4 hero-glass-description">{heroData.description}</p>
            <div className="action-btns mt-4 hero-glass-buttons">
              <Link
                to={heroData.primaryCTA.link}
                className={`${heroData.primaryCTA.className} mr-3 mb-3 hero-glass-btn-primary`}
              >
                {heroData.primaryCTA.text}
                <i className="fas fa-arrow-right pl-2"></i>
              </Link>
              <a
                href={heroData.secondaryCTA.link}
                className={`${heroData.secondaryCTA.className} mb-3 hero-glass-btn-secondary`}
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.querySelector(heroData.secondaryCTA.link);
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                }}
              >
                {heroData.secondaryCTA.text}
                <i className="fas fa-external-link-alt pl-2"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-12">
          {/* Blank space - no styling */}
        </div>
      </div>
    </div>
  );

  return (
    <section
      className="position-relative bg-image pt-60 pb-100 webbuilder-hero-section"
      image-overlay="8"
    >
      <div
        className="background-image-wraper"
        style={{
          background: `url('/assets/img/homepage-wb.svg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 1,
        }}
      ></div>
      {renderGlassmorphism()}
    </section>
  );
}

export default WebBuilderHero;
